import { useState } from 'react'
import { Section } from './Section'
import { focusOnMount } from '../../hooks/useAutoFocus'

// One list per account: joining another moves you there (switch_household).
export function JoinSection({ householdName, onSwitchHousehold, onJoined }: {
  householdName: string
  onSwitchHousehold: (code: string) => Promise<string | null>
  onJoined: () => void
}) {
  const [open, setOpen] = useState(false)
  const [code, setCode] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [joining, setJoining] = useState(false)

  async function join() {
    if (!code.trim() || joining) return
    setJoining(true)
    setError(null)
    const err = await onSwitchHousehold(code.trim())
    setJoining(false)
    if (err) { setError(err); return }
    onJoined()
  }

  return (
    <Section title="Another household">
      <div className="ml-settings__card">
        {open ? (
          <>
            <p className="ml-settings__sub">Enter an invite code to leave {householdName} and join another list.</p>
            <div className="ml-settings__join">
              <input className="ml-input ml-num" aria-label="Invite code" placeholder="AB1C2D" ref={focusOnMount} value={code}
                onChange={e => { setCode(e.target.value.toUpperCase()); setError(null) }}
                onKeyDown={e => { if (e.key === 'Enter') join() }} />
              <button type="button" className="ml-btn ml-btn--primary" disabled={joining || !code.trim()} onClick={join}>
                {joining ? 'One moment…' : 'Join'}
              </button>
            </div>
            {error && <p className="ml-settings__error" role="alert">{error}</p>}
          </>
        ) : (
          <button type="button" className="ml-text-btn" onClick={() => setOpen(true)}>Join another list</button>
        )}
      </div>
    </Section>
  )
}
